import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appElHeightBottom]',
    standalone: false
})
export class ElHeightBottomDirective {
	constructor(el: ElementRef) {
		setTimeout(() => {
			el.nativeElement.style.bottom =
				'-' + el.nativeElement.offsetHeight + 'px';
			el.nativeElement.style.opacity = '1';
		}, 0);
	}
}
